<template>
  <div
    class="absolute top-0 flex h-screen transform flex-col justify-between overflow-y-auto border-l-0-5 border-gray-600 bg-light-blue-900 px-4 pt-8 text-white transition-all duration-500"
    @click.prevent
  >
    <div class="flex flex-col">
      <div
        v-if="filteredList?.name"
        class="mb-4 ml-1 bg-light-blue-900 text-base font-semibold text-gray-100"
      >
        {{ filteredList.name }}
      </div>
      <div class="w-59">
        <search-input
          v-model="searchTerm"
          :placeholder="placeholder"
          dark-theme
          small-size
          clear-button-enabled
        />
      </div>
      <div v-for="(option, i) in filteredList?.items" :key="i">
        <router-link
          :to="{ path: option.link, query: { stage: option.status.stageName } }"
        >
          <div
            class="flex max-w-63 cursor-pointer flex-col justify-start space-y-2 border-t-0-5 border-b-0-5 border-gray-600 p-2 font-medium text-gray-300 hover:bg-gray-600"
          >
            <span class="truncate overflow-hidden">{{ option.label }}</span>
            <status-label :status="option.status" />
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import StatusLabel from "@/components/ui/StatusLabel.vue";

import type { DealStatusRecord } from "@/models/state";
import type { PropType } from "vue";

export interface IRecentListItem {
  label: string;
  link: string;
  status: DealStatusRecord;
}

export interface IRecentList {
  name: string;
  items: IRecentListItem[];
}

const props = defineProps({
  recentList: {
    type: Object as PropType<IRecentList | null>,
    default: null,
  },
  placeholder: {
    type: String,
    default: "Search",
  },
});

const searchTerm = ref("");

const filteredList = computed(() => {
  if (!searchTerm.value) {
    return props.recentList;
  }
  return {
    ...props.recentList,
    items: props.recentList?.items.filter((item) =>
      item.label.toLowerCase().includes(searchTerm.value.toLowerCase())
    ),
  };
});
</script>
